import { useEffect } from "react";
import { IHook } from "./homeReferral.types";

export const useHomeReferral: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
